export default __webpack_public_path__ + "static/media/browserView.6f3f5930.gif";